var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "solutionguide__step-wrapper" },
    [
      _c("p", { staticClass: "lead" }, [
        _vm._v(
          _vm._s(
            _vm.$t(_vm.step + ".headline", {
              segment:
                _vm.$store.state.segment && _vm.$store.state.segment.name,
              application:
                _vm.$store.state.application &&
                _vm.$store.state.application.name,
              component:
                _vm.$store.state.component && _vm.$store.state.component.name,
            })
          )
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }